// libraries
import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

export function QueueControl() {
  const { tenant: tenantUrl } = useParams();
  return (
    <span className="queue-control d-flex-center mr-5">
      <NavLink
        to={`/${tenantUrl}/cn/list`}
        className={({ isActive }) => `d-flex${isActive ? ' active' : ''}`}
        data-test="patientListLink"
      >
        <i className="queue-icon d-flex-center bi-filter-left mr-1" />
        <span>Patients Queue</span>
      </NavLink>
    </span>
  );
}

export default QueueControl;
